import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c18d174&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c18d174')) {
      api.createRecord('5c18d174', component.options)
    } else {
      api.reload('5c18d174', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c18d174&", function () {
      api.rerender('5c18d174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/buildingUnit/index.vue"
export default component.exports